/** A hand-edited file can hold anything; only usable strings get through. */
export function configReadString(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}
